import { render, staticRenderFns } from "./ComixOverview.vue?vue&type=template&id=ae441fa2&scoped=true&"
import script from "./ComixOverview.vue?vue&type=script&lang=js&"
export * from "./ComixOverview.vue?vue&type=script&lang=js&"
import style0 from "./ComixOverview.vue?vue&type=style&index=0&id=ae441fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae441fa2",
  null
  
)

export default component.exports